import React, { useContext } from 'react';
import Layout from './components/base.jsx';
import Hero from './components/Hero';
import Features from './components/Features';
import Argument from './components/Argument.jsx';
import Carrusel from './components/ActionSection';
import StatsSection from './components/StatsSection';
import Partners from './components/Partners';
import ContactForm from './components/ContactForm';
import Chatbot from './components/Demo/Chatbot.jsx'; 
import { ChatbotProvider, ChatbotContext } from './Context/ChatbotContext.jsx';
import { ChatbotStateProvider } from './Context/ChatbotStateContext'; 

function AppContent() {
  const { isChatOpen, isMobile } = useContext(ChatbotContext);

  // Si el chat está abierto en móvil, ocultar el resto de la aplicación
  if (isChatOpen && isMobile) {
    return <Chatbot />;
  }

  return (
    <Layout>
      <Hero />
      <Partners />
      <Argument />
      <Features />
      <Carrusel />
      <StatsSection />
      <ContactForm />
      <Chatbot /> 
    </Layout>
  );
}

function App() {
  return (
    <ChatbotProvider>
      <ChatbotStateProvider>
        <AppContent />
      </ChatbotStateProvider>
    </ChatbotProvider>
  );
}

export default App;
